import { render, staticRenderFns } from "./PermissionTemplateDropdown.vue?vue&type=template&id=a26f4c76&scoped=true&"
import script from "./PermissionTemplateDropdown.vue?vue&type=script&lang=js&"
export * from "./PermissionTemplateDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PermissionTemplateDropdown.vue?vue&type=style&index=0&id=a26f4c76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26f4c76",
  null
  
)

export default component.exports